/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Removed_SuccessInputs */



/**
* | output |
* | --- |
* | "User was successfully removed" |
*
* @param {Team_Manager_User_Removed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_removed_success = /** @type {((inputs?: Team_Manager_User_Removed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Removed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateur supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Benutzer wurde erfolgreich entfernt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'utente è stato rimosso con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользователь был успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El usuario fue eliminado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーは正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को सफलतापूर्वक हटा दिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usuário removido com sucesso")
	return /** @type {LocalizedString} */ ("User was successfully removed")
});